export default [
  {
    path: '/admin/allowance-conditions',
    name: 'allowance-condition',
    meta: { requiresAuth: true },
    component: () => import('@/pages/mission/allowance-condition/index.vue')
  },
]
